import { observer }            from 'mobx-react';
import React                   from 'react';
import { Button }              from 'antd';
import { Col }                 from 'antd';
import CardBox                 from './CardBox';
import FormattedMessageWrapper from './FormattedMessageWrapper';
import Row                     from './Row';

interface DashboardComponentProps {
  body: any;
  dataLoading?: boolean;
  headContent: any;
  model: any;
  title?: any;
  topRightComponent: any;
}

@observer
class DashboardComponent extends React.Component<DashboardComponentProps> {
  public render() {
    const { dataLoading, model } = this.props;

    return (
      <>
        <div className="page-loading">
          {dataLoading && (
            <Button htmlType="button" loading>
              <FormattedMessageWrapper id="Chargement" />
            </Button>
          )}
        </div>

        <div>
          <Row>
            <Col span={24}>
              <CardBox
                content={this.props.headContent}
                extra={this.props.topRightComponent}
                loading={model.isLoading}
                title={this.props.title}
              />
            </Col>
            <Col span={24}>
              {this.props.body}
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export default DashboardComponent;
